<div class="dialog">
  <form #form="ngForm">
    <h4 mat-dialog-title>{{ 'dialog_right_user_title' | translate }}</h4>
    <mat-card>
      <mat-form-field>
        <mat-label>{{ 'common_field_profile' | translate }}</mat-label>
        <mat-select name="profil" [value]="selectedRight?.profileCode" (selectionChange)="getTypesPerimeter($event?.value)" required>
          <mat-option *ngFor="let code of profilesCode" [value]="code">{{ code }}</mat-option>
        </mat-select>
        <mat-error *ngIf="!selectedRight?.profileCode" [innerHTML]="'common_error_profile_required' | translate"></mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'common_field_perimeter_type' | translate }}</mat-label>
        <mat-select name="perimeterType" [value]="selectedRight?.perimeterType" (selectionChange)="getPerimeters($event?.value)" required>
          <mat-option *ngFor="let perimeterType of typesPerimeter" [value]="perimeterType">{{ perimeterType }}</mat-option>
        </mat-select>
        <mat-error *ngIf="!selectedRight?.perimeterType" [innerHTML]="'common_error_perimeter_type_required' | translate"></mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'common_field_perimeter' | translate }}</mat-label>
        <mat-select name="perimeter" [value]="selectedRight" [(ngModel)]="selectedRight" required>
          <mat-option *ngFor="let item of perimeters" [value]="item">{{ item?.perimeterDisplayName }}</mat-option>
        </mat-select>
        <mat-error *ngIf="!selectedRight?.perimeterDisplayName" [innerHTML]="'common_error_perimeter_required' | translate"></mat-error>
      </mat-form-field>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="selectedRight" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
